import * as React from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function DialogTravel({ open, onOpenChange, children }) {
    return (
        <div className={cn("fixed inset-0 z-50 flex items-end", open ? "visible" : "invisible")} onClick={onOpenChange}>
            <div className="w-full bg-white rounded-t-2xl shadow-lg">{children}</div>
        </div>
    );
}

export function DialogContent({ children, className }) {
    return <div className={cn("p-4", className)}>{children}</div>;
}

export function DialogHeader({ children }) {
    return <div className="pb-4 border-b">{children}</div>;
}

export function DialogTitle({ children, className }) {
    return <h2 className={cn("text-lg font-semibold", className)}>{children}</h2>;
}
